import React from "react";
import { useAuthentication } from "@planzone/view-models";

import { VisibilityWatcher } from "@common/visibilityWatcher";
import { MemberAvatar } from "@common/memberAvatar";
import { Props } from "./types";
import { Menu } from "./menu";
import styles from "./styles.scss";

function ProfileNavigation(props: Props) {
  const { account } = useAuthentication();

  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div
          className={styles.profileNavigation}
          onClick={isVisible ? hide : show}
        >
          <div className={styles.user}>
            <div className={styles.avatar}>
              <MemberAvatar
                name={account.resource.name}
                avatarUrl={account.resource.avatarUrl}
              />
            </div>
          </div>
          {isVisible && (
            <div className={styles.menu}>
              <Menu name={`${account.firstName} ${account.lastName}`} />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ProfileNavigation };
